import { render, staticRenderFns } from "./messageGroups.vue?vue&type=template&id=4ef99c8e&"
import script from "./messageGroups.vue?vue&type=script&lang=js&"
export * from "./messageGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports